export default __webpack_public_path__ + "static/third-540b92102888a4e1bf735125a5a93bd1.jpg";